import { render, staticRenderFns } from "./AddProductToCart.vue?vue&type=template&id=2b1d0522"
import script from "./AddProductToCart.vue?vue&type=script&lang=js"
export * from "./AddProductToCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports